import { t } from "@redotech/redo-i18n";
import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { submitWarrantyRegistrationFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isSubmitWarrantyRegistrationStepValid,
  SubmitWarrantyRegistrationState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SUBMIT_WARRANTY_REGISTRATION = (
  Details: React.ComponentType<
    StepTypeDetailsProps<SubmitWarrantyRegistrationState>
  >,
): StepType<
  SubmitWarrantyRegistrationState,
  ModelStep.SubmitWarrantyRegistration
> => ({
  Details: (props: StepTypeDetailsProps<SubmitWarrantyRegistrationState>) =>
    React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  title: STEP_TYPE_NAMES[ModelStep.SUBMIT_WARRANTY_REGISTRATION],
  valid(state) {
    return isSubmitWarrantyRegistrationStepValid(state).valid;
  },
  Icon: ShieldTickIcon,
  iconColor: "success",
  description(state) {
    return t("Submit warranty registration");
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {},
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_WARRANTY_REGISTRATION,
    };
  },
  fromModel(model) {
    return submitWarrantyRegistrationFromModel(model);
  },
});
